var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('TelefonoNavar'),_c('TelefonoBanner'),_c('CategoriasView'),_c('ServiciosFAQ'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }